import type { SystemNode } from "./types";

export function indexNodesById(
  nodes: readonly SystemNode[],
): Record<string, SystemNode> {
  return Object.fromEntries(nodes.map((n) => [n.id, n]));
}

export function findEnclosingZoneId(
  nodeId: string,
  nodes: SystemNode[],
): string | undefined {
  const start = nodes.find((n) => n.id === nodeId);
  if (!start) return undefined;
  let cur: SystemNode = start;
  while (cur.parentId) {
    const parent = nodes.find((n) => n.id === cur.parentId);
    if (!parent) return undefined;
    if (parent.kind === "zone") return parent.id;
    cur = parent;
  }
  return undefined;
}
